<template>
    <div class="animated fadeIn">
        <b-card no-body>
            <b-card-body fluid="xl">
                <b-card-title class="text-center mb-2">
                    <h2>Visitor Entry</h2>
                </b-card-title>
                <b-overlay :show="loading" rounded="sm">        
                <b-form @submit.stop.prevent="onSubmit">
                    <b-row>
                        <b-col>

                            <b-form-group label="Errors" v-if="showDismissibleAlert">
                                <b-alert variant="danger" :show="showDismissibleAlert"
                                    @dismissed="showDismissibleAlert = false" dismissible fade>
                                    <span v-for="items in submissionErros">
                                        <ul v-for="item in items">
                                            <li> {{ item }} </li>
                                        </ul>
                                    </span>

                                </b-alert>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Id Number" label-class="font-weight-bold" label-for="idNumber">
                                <b-form-input id="idNumber" :state="validateState('idNumber')" name="idNumber"
                                    aria-describedby="liveFeedbackIdNumber" v-model.lazy.trim="$v.form.idNumber.$model"
                                    autofocus />
                                <b-form-invalid-feedback id="liveFeedbackIdNumber">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Name" label-class="font-weight-bold" label-for="visitorname">
                                <b-form-input id="visitorname" name="visitorname" :state="validateState('visitorname')"
                                    aria-describedby="liveFeedbackVisitorname" v-model="$v.form.visitorname.$model" />
                                <b-form-invalid-feedback id="liveFeedbackVisitorname">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Mobile Number" label-class="font-weight-bold" label-for="visitormobile">
                                <b-form-input id="visitormobile" name="visitormobile" :state="validateState('visitormobile')"
                                    aria-describedby="liveFeedbackVisitorMobile" v-model="$v.form.visitormobile.$model" />
                                <b-form-invalid-feedback id="liveFeedbackVisitorMobile">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Purpose Of Visit" label-class="font-weight-bold" label-for="visitpurpose">
                                <b-form-select ref="visitpurpose" id="visitpurpose" name="visitpurpose"
                                    :class="{ danger: $v.form.visitpurpose.$error }"
                                    :state="validateState('visitpurpose')" :options="purposeList"
                                    aria-describedby="liveFeedbackpurpose" v-model="$v.form.visitpurpose.$model"
                                    value-field="id"  text-field="name"
                                    @change="toggleFields"></b-form-select>
                                <span v-show="$v.form.visitpurpose.$error" class="danger-span">
                                    This is required field
                                </span>
                                <b-form-invalid-feedback id="liveFeedbackpurpose">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="showHouseQuater">
                        <b-col>
                            <b-form-group label="Name of Soamibagh Satsangi Visiting" label-class="font-weight-bold" label-for="visitingname">
                                <b-form-input id="visitingname" visitingname="visitingname"
                                    :state="validateState('visitingname')" v-model="$v.form.visitingname.$model" />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group label="Quarter No" label-class="font-weight-bold" label-for="houseno">
                                <b-form-input id="houseno" name="houseno" :state="validateState('houseno')"
                                    v-model="$v.form.houseno.$model" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="showSatsangOfficial">
                        <b-col>
                            <b-form-group label="Name of satsang official" label-class="font-weight-bold" label-for="satsangofficial">
                                <b-form-input id="satsangofficial" name="satsangofficial"
                                    :state="validateState('satsangofficial')"
                                    v-model="$v.form.satsangofficial.$model" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="showOtherPurpose">
                        <b-col>
                            <b-form-group label="please specify" label-class="font-weight-bold" label-for="otherpurpose">
                                <b-form-input id="otherpurpose" name="otherpurpose"
                                    :state="validateState('otherpurpose')" v-model="$v.form.otherpurpose.$model" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Number of accompanying visitors" label-class="font-weight-bold" label-for="gents">
                                <b-form-spinbutton id="gents" v-model="$v.form.$model.gents" min=0 max=10000
                                    @change="checkMembers" inline></b-form-spinbutton>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Number of visitors"  label-for="numberMembers"
                                label-class="font-weight-bold">
                                <b-input-group>
                                    <b-input-group-prepend>
                                        <b-button variant="outline-info" @click="removeMember">Remove Visitor</b-button>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="numberOfMembers" disabled></b-form-input>
                                    <b-input-group-append>
                                        <b-button variant="success" @click="addMember">Add Visitor</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <non-satsangi-member-list ref="memberList"></non-satsangi-member-list>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="VehicleNo" label-class="font-weight-bold" label-for="vehicleNo">
                                <b-form-input id="vehicleNo" name="vehicleNo" v-model.lazy.trim="form.vehicleNo" />
                            </b-form-group>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Country" label-class="font-weight-bold" label-for="country">
                                <v-select ref="country" id="country" name="country"
                                    @search:blur="$v.form.country.$touch()" :state="validateState('country')"
                                    :options="countriesList" v-model="$v.form.country.$model"
                                    :reduce="country => country.id" label="name"></v-select>


                            </b-form-group>
                        </b-col>

                        <b-col>
                            <b-form-group label="State" label-class="font-weight-bold" label-for="state">
                                <b-form-input id="state" name="state" :state="validateState('state')"
                                    v-model="$v.form.state.$model" />

                            </b-form-group>

                        </b-col>
                    </b-row>
                </b-form>
                </b-overlay>
                <b-row>
                        <b-col>
                            <b-button ref="submitButton" type="submit"  @click="onSubmit" variant="primary" :disabled="$v.form.$invalid">
                                Save
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button class="ml-1" type="reset" @click="onReset">Reset</b-button>
                        </b-col>
                        <b-col>
                            <b-button class="ml-1"  @click="stopLoading">Stop Loading</b-button>
                        </b-col>
                        <b-col v-if="showPrintButton">
                            <b-button class="ml-1"  variant="info" @click="callReceiptService">Re-Print</b-button>
                        </b-col>
                    </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import NonSatsangiMemberList from './NonSatsangiMemberList'

import map from 'lodash/map'
import {
    mapState,
    mapActions
} from 'vuex'

import { validationMixin } from "vuelidate";
import { required, minLength, numeric, minValue, maxLength, email, alpha, helpers, requiredIf } from "vuelidate/lib/validators";

const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)


const receiptShape = {
    receiptType: "gate",
    visitdate: null,
    name: null,   
    id: null,
    totalVisited: 1
}

const formShape = {
    idNumber: null,
    visitorname: null,
    state: null,
    visitpurpose: null,
    gents: 0,
    country: null,
    vehicleNo: "",
    members: null,
    visitingname: null,
    houseno: null,
    otherpurpose: null,
    satsangofficial: null,
    purpose: null,
    visitormobile: null

}
export default {
    mixins: [validationMixin],
    name: "NonSatsangiEntry",
    components: {
        NonSatsangiMemberList
    },
    data() {
        return {
            form: Object.assign({}, formShape),
            receipt: Object.assign({}, receiptShape),
            submitted: false,
            showDismissibleAlert: false,
            submissionErros: "",
            selectedSearchOption: false,
            visitors: [],
            showPrintButton: false,
            showOtherPurpose: false,
            showHouseQuater: false,
            showSatsangOfficial: false,
            numberOfMembers: 0,
            loading: false,
        }
    },

    validations: {
        form: {
            idNumber: {
                required
            },
            visitorname: {
                required,
                alpha_space,
                maxLength: maxLength(200)
            },
            visitormobile: {
                required,
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(12)
            },

            state: {

            },
            visitpurpose: {
                required
            },
            gents: {
                required
            },
            country: {

            },
            vehicleNo: {

            },
            members: {
                required: requiredIf(function(nestedModel) {
                    return this.getMembersCount() > 0;
              }),
                $each: {
                    name: {
                        required,
                        alpha_space
                    },

                    phone: {
                        required,
                        numeric,
                        minLength: minLength(10),
                        maxLength: maxLength(12)
                    }
                }
            },
            visitingname: {
                alpha_space,
                required: requiredIf(function(nestedModel) {
                    return this.showHouseQuater == true;
          }),
          
            },
            houseno: {
                required: requiredIf(function(nestedModel) {
                    return this.showHouseQuater == true;
          }),

            },
            otherpurpose: {
                required: requiredIf(function(nestedModel) {
                    return this.showOtherPurpose == true;
          }),
          

            },
            satsangofficial: {
                required: requiredIf(function(nestedModel) {
                    return this.showSatsangOfficial == true;
          }),

            },




        }
    },
    watch: {
    },
    computed: {

        isValid() {
            this.$v.$touch();
            return !this.$v.form.$anyError
        },
        isDirty() {
            return this.$v.form.$anyDirty
        },
        purposeList() {
            return map(this.$store.state.gate.visit_purpose, (purpose) => {
                return {
                    name: purpose.name,
                    id: purpose.id
                }

            })
        },
        countriesList() {
            return map(this.$store.state.samadh.countries, (country) => {
                return {
                    name: country.name,
                    id: country.id
                }

            })
        },
    },
    methods: {
        stopLoading(){
            this.loading = false;
        },
        checkMembers(){
            if(this.getMembersCount() > this.form.gents){
                this.$refs.memberList.removeMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.members = this.$refs.memberList.getMembers()
            }
            else{
                this.$refs.memberList.addMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.members = this.$refs.memberList.getMembers()
            }
        },
        toggleFields(){
            console.log('toogleField');
            this.showOtherPurpose = false;
            this.showHouseQuater = false;
            this.showSatsangOfficial = false;  

            this.form.visitingname = null;
            this.form.houseno = null;
            this.form.otherpurpose = null;
            this.form. satsangofficial = null;
            this.form.purpose = null;


            if(this.form.visitpurpose != null && this.form.visitpurpose != null && (this.form.visitpurpose == 1 || this.form.visitpurpose == 2 ||this.form.visitpurpose == 3 )){
                this.showHouseQuater = true;               
            }
            else if(this.form.visitpurpose != null && this.form.visitpurpose != null && this.form.visitpurpose == 4){
                this.showSatsangOfficial = true
            }
            else if(this.form.visitpurpose != null && this.form.visitpurpose != null && this.form.visitpurpose == 5){
                this.showOtherPurpose = true
            }
        },

        onCancel() {
            this.$emit('cancel')
        },
        addMember() {
            if (this.numberOfMembers < 500) {
                this.$refs.memberList.addMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.gents = this.form.gents + 1;
                this.form.members = this.$refs.memberList.getMembers()
            }
        },
        
        getMembersCount(){
        return this.$refs.memberList.getMembersCount()
      },
        removeMember() {
            if (this.numberOfMembers > 0) {                
                this.$refs.memberList.removeMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.gents = this.form.gents - 1;
                this.form.members = this.$refs.memberList.getMembers()
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        callReceiptService() {
            this.$nextTick(() => {
                let params = JSON.stringify(this.receipt);
                console.log(params);
                this.$store.dispatch('samadh/printReceipt', params)
                    .then((response) => {
                        console.log(response.data.status);
                        if (response.data.status == 'error') {
                            if (response.data.message != null) {
                                this.showErrorMsg({
                                    message: "Print Failed: " + response.data.message
                                });
                            }
                            else {
                                this.showErrorMsg({
                                    message: "Print Failed. Please check Print service is running."
                                });
                            }

                            this.showPrintButton = true;

                        }
                        else {
                            this.showPrintButton = false;
                            this.$emit('success')
                            this.onReset();

                        }
                    })
                    .catch((error) => {
                        if (error.response != null && error.response.data.message != null) {
                            this.showErrorMsg({
                                message: "Print Failed: " + error.response.data.message
                            });
                        }
                        else {
                            this.showErrorMsg({
                                message: "Print Failed. Please check Print service is running."
                            });
                        }

                        this.showPrintButton = true;

                    })
            });

        },
        async printReceipt(data) {

            this.receipt.receiptType = "gate";
            this.receipt.visitdate = data.visitdate;
            this.receipt.name = data.visitorname;
            this.receipt.id = data.id != null ? data.id.toString() : null;
            this.receipt.totalVisited = data.totalPeople == 0 ? 1 : data.totalPeople;
            this.receipt.vehicleno = data.vehicleno;


            await this.callReceiptService();



        },
        onSubmit() {
            if (this.submitted == false) {
                this.submitted = true;
                let totalPeople = this.form.gents + 1;      
                let visitPurpose = {
                    purpose_id: this.form.visitpurpose,
                    visitingname : this.form.visitingname,
                    houseno: this.form.houseno,
                    otherpurpose: this.form.otherpurpose,
                    satsangofficial: this.form.satsangofficial,
                    country: this.form.country,
                    state: this.form.state,
                    vehicleno: this.form.vehicleNo,
                    visitormobile: this.form.visitormobile
                }         
                let params = {
                    
                    fromdate: this.formatDate(new Date()),
                    todate: this.formatDate(new Date()),
                    departure_time: null,
                    people: totalPeople,
                    children: 0,
                    adults: this.form.gents + 1,
                    members: this.$refs.memberList.getMembers(),
                    visit_purpose: visitPurpose,
                    isnonsatsangi: true,
                    visitorname : this.form.visitorname

                };
                Vue.axios.post("/admin/createGateVisitorEntry", params)
                    .then(response => {
                        console.log(response);
                        if (response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        }
                        else if (typeof response.data !== "undefined" && response.data.success == true) {
                            this.showSuccessMsg({ message: "Entry created successfully." });
                            this.onReset()
                            if(this.reservation != null){
                                this.$emit('success', this.reservation);
                            }
                            this.printReceipt(response.data.data);
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.message });
                              
                            }
                            else {
                                this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                            this.showDismissibleAlert = true;
                            var errors = Object.values(error.response.data.errors);
                            this.submissionErros = errors;
                        } else {
                            this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                        }
                    })
                console.log(this.form);
                this.submitted = false;
            }
        },
        onReset() {
            // Reset validation
            this.form = Object.assign({}, formShape);
            this.receipt = Object.assign({}, receiptShape);
            this.submitted = false
            this.$refs.memberList.onReset()
            this.numberOfMembers = this.getMembersCount();
            this.idNumber = null;
            this.loading = false;
            this.submitted = false;
            this.form.gents = 0;
            this.form.country = { "id": "IND", "name": "India" };
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    beforeMount() { },
    created() {
        if (this.$store.state.samadh.countries.length == 0) {
            this.$store.dispatch('samadh/getCountries')
        }
        if (this.$store.state.gate.visit_purpose.length == 0) {
            this.$store.dispatch('gate/getVisitPurposes')
        }
       
        this.form.country = { "id": "IND", "name": "India" };
    }
}
</script>

<style media="screen">
.danger,
.danger .dropdown-toggle,
.danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
}

.danger-span {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

}

.borderCard {
    border: 1px solid #e3e8ec;
}
</style>